import { Menu, HelpCircle } from "lucide-react";
import React from "react";
import { NavLink } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/avatar";
import { Button } from "../../components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/dropdown-menu";
import { useTranslation } from "react-i18next";
import { useAuthSession } from "../auth/shared";

interface MerchantTopbarProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  onLogout: () => void;
}

const MerchantTopbar: React.FC<MerchantTopbarProps> = ({
  sidebarOpen,
  setSidebarOpen,
  onLogout,
}) => {
  const { t } = useTranslation();
  const { user } = useAuthSession();

  return (
    <header className="sticky top-0 z-40 flex items-center h-16 min-h-16 px-8 bg-white border-b border-r-0 justify-end dark:bg-gray-900 dark:border-gray-800">
      {/* Mobile menu button */}
      <div className="flex items-center gap-2 lg:hidden absolute left-8">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setSidebarOpen(true)}
        >
          <Menu className="h-5 w-5" />
        </Button>
      </div>

      {/* Right side actions */}
      <div className="flex items-center gap-4">
        {/* Help Center */}
        <Button
          variant="ghost"
          size="icon"
          onClick={() => window.open("https://helpdesk.civicpoints.io/", "_blank")}
          aria-label="Help Center"
        >
          <HelpCircle className="h-5 w-5" />
        </Button>

        {/* Profile dropdown */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Avatar className="cursor-pointer">
              <AvatarImage
                src={user?.profile_image_url}
                alt="Profile"
              />
              <AvatarFallback>{user?.email?.[0]?.toUpperCase() || "M"}</AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="w-56"
          >
            <DropdownMenuLabel>{t("common.my_account")}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <NavLink to="/merchant/profile">{t("common.profile")}</NavLink>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <NavLink to="/merchant/business-profile">Business Profile</NavLink>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <NavLink to="/merchant/my-plan">My Plan</NavLink>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-red-600"
              onClick={onLogout}
            >
              {t("common.logout")}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default MerchantTopbar;
